import UserList from "../users/UserList";
import UserSearch from "../users/UserSearch";

const Home = () => {
  return (
    <div>
      <UserSearch />
      <UserList />
    </div>
  );
};

export default Home;
